const ALL_SITE_DESIGNS = {
  value: "all-site-designs",
  label: "All Site Designs",
  iconType: "",
  hasAssigned: false,
};

const UNCATEGORIZED = {
  value: "uncategorized",
  label: "Uncategorized",
  iconType: "folderClosed",
  isAddNew: false,
};

const ADD_NEW_FOLDER = {
  value: "add-new",
  label: "Add New Folder",
  iconType: "add",
  isAddNew: true,
};

const SITE_FOLDER_DEFAULT_CONSTANT_OPTIONS = [ALL_SITE_DESIGNS, UNCATEGORIZED, ADD_NEW_FOLDER];

const SYSTEM_RESERVED_FOLDER_NAMES = ["All Site Designs", "Uncategorized", "Add New Folder"];

const SiteFolderConstants = {
  ALL_SITE_DESIGNS,
  UNCATEGORIZED,
  ADD_NEW_FOLDER,
  SITE_FOLDER_DEFAULT_CONSTANT_OPTIONS,
  SYSTEM_RESERVED_FOLDER_NAMES,
  CREATE_MODE: "create",
  RENAME_MODE: "rename",
  ALL_SITE_DESIGNS_FOLDER_ID: ALL_SITE_DESIGNS.value,
  UNCATEGORIZED_FOLDER_ID: UNCATEGORIZED.value,
  ADD_NEW_FOLDER_ID: ADD_NEW_FOLDER.value,
  ALL_SITE_DESIGNS_FOLDER_LABEL: ALL_SITE_DESIGNS.label,
  UNCATEGORIZED_FOLDER_LABEL: UNCATEGORIZED.label,
  ADD_NEW_FOLDER_LABEL: ADD_NEW_FOLDER.label,
};

export default SiteFolderConstants;
